import * as React from 'react';

import { Link } from '@gitbook/react-uikit';
import {
    Description,
    FieldError,
    FieldGroup,
    Label,
    Panel,
    PanelBody,
    TextInput,
} from '@gitbook/spine-react';
import { isHttpUrl } from '@gitbook/util-url';

import type { SitesCustomizationPanelProps } from '../types';

/**
 * Settings to configure the privacy policy
 */
export function PrivacyPolicySettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;
    const [touched, setTouched] = React.useState(false);

    const errorMessage: string | null = (() => {
        if (!settings.privacyPolicy?.url || isHttpUrl(settings.privacyPolicy.url)) {
            return null;
        }

        return 'Must be a valid URL';
    })();

    const invalid = touched && errorMessage !== null;

    return (
        <Panel aria-label="Privacy policy">
            <PanelBody>
                <FieldGroup>
                    <Label>Privacy policy URL</Label>
                    <Description>
                        Provide a privacy policy URL to help visitors understand cookie tracking.
                        Otherwise, the GitBook{' '}
                        <Link url="https://policies.gitbook.com/privacy/cookies">
                            privacy policy
                        </Link>{' '}
                        will be used.
                    </Description>
                    <TextInput
                        type="url"
                        placeholder="https://mycompany.com/privacy-policy"
                        value={settings.privacyPolicy.url || ''}
                        onChange={(event) => {
                            const { value } = event.target;
                            setSettings((prev) => ({
                                ...prev,
                                privacyPolicy: value ? { url: value } : {},
                            }));
                        }}
                        onBlur={() => setTouched(true)}
                        aria-invalid={invalid || undefined}
                    />
                    {invalid && <FieldError>{errorMessage}</FieldError>}
                </FieldGroup>
            </PanelBody>
        </Panel>
    );
}
